import { motion } from "framer-motion";
import { ArrowDown } from "lucide-react";

const HERO_IMAGE =
  "https://images.unsplash.com/photo-1762649924707-4955e5566bb8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwzfHxibGFjayUyMHdoaXRlJTIwYmx1cnJlZCUyMGxhbmRzY2FwZSUyMGRhcmt8ZW58MHx8fHwxNzc4NDQ4MDMyfDA&ixlib=rb-4.1.0&q=85";

export const Hero = () => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative h-[100svh] min-h-[640px] w-full overflow-hidden"
    >
      {/* Background image */}
      <motion.div
        initial={{ opacity: 0, scale: 1.04 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 3.4, ease: [0.22, 0.61, 0.36, 1] }}
        className="absolute inset-0"
      >
        <img
          src={HERO_IMAGE}
          alt=""
          aria-hidden="true"
          className="w-full h-full object-cover"
          style={{
            filter: "grayscale(100%) contrast(0.95) brightness(0.55)",
          }}
        />
      </motion.div>

      {/* Heavy darkening + vignette */}
      <div className="absolute inset-0 bg-[#080808]/65" />
      <div className="absolute inset-0 kv-vignette" />

      {/* Top horizon line */}
      <div className="absolute top-24 left-6 sm:left-10 md:left-16 right-6 sm:right-10 md:right-16 h-px bg-[#1a1a1a]" />

      {/* Frame meta */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 2.4, delay: 1.2 }}
        className="absolute top-28 left-6 sm:left-10 md:left-16 right-6 sm:right-10 md:right-16 flex items-center justify-between"
      >
        <span className="kv-overline text-[#6b6b6b]">N° 01</span>
        <span className="kv-overline text-[#6b6b6b]">MMXXVI</span>
      </motion.div>

      {/* Wordmark */}
      <div className="relative z-10 h-full flex flex-col justify-center items-center px-6 text-center">
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 2.6, delay: 0.6 }}
          className="kv-overline text-[#a3a3a3] mb-8"
        >
          Instrumental Cinematic Works
        </motion.p>

        <motion.h1
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 3.0, delay: 1.0, ease: "easeOut" }}
          data-testid="hero-wordmark"
          className="kv-wordmark text-[#f2f0e9] text-[clamp(2.6rem,11vw,9rem)] leading-[0.92]"
        >
          KACHEVSKY
        </motion.h1>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 2.6, delay: 1.8 }}
          className="mt-10 flex items-center justify-center"
        >
          <span className="kv-overline text-[#a3a3a3]">
            Composer
          </span>
        </motion.div>
      </div>

      {/* Bottom row: scroll indicator + location */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 2.4, delay: 2.4 }}
        className="absolute bottom-8 left-6 sm:left-10 md:left-16 right-6 sm:right-10 md:right-16 grid grid-cols-3 items-end"
      >
        <span className="kv-overline text-[#6b6b6b]" />
        <a
          href="#release"
          data-testid="hero-scroll-cue"
          className="justify-self-center flex flex-col items-center gap-3 text-[#a3a3a3] hover:text-[#f2f0e9] transition-colors duration-700"
        >
          <span className="kv-overline">Descend</span>
          <ArrowDown className="w-4 h-4 animate-pulse" strokeWidth={1} />
        </a>
        <span className="justify-self-end kv-overline text-[#6b6b6b] font-mono-archive">
          41.88 N, 87.63 W
        </span>
      </motion.div>
    </section>
  );
};

export default Hero;
